import { APIService } from '../../../lib/api/APIService';

// Application Builder API class extending the base APIService
class ApplicationBuilderAPI extends APIService {
  async getProfile() {
    return this.get('/api/application-builder/profile');
  }

  async generateDocument(data) {
    return this.post('/api/application-builder/generate', data);
  }

  async improveText(text, sectionType, context = '', useAI = true) {
    return this.post('/api/application-builder/improve-text', {
      text,
      section_type: sectionType,
      context,
      use_ai: useAI
    });
  }

  async getFeedback(questionNum, content, subject = '', useAI = true, options = {}) {
    const snapshot = options.snapshot || {};
    return this.post(
      '/api/application-builder/get-feedback',
      {
        question_num: questionNum,
        content,
        subject,
        use_ai: useAI,
        oxbridge: Boolean(options.oxbridge),
        session_id: options.sessionId || undefined,
        polish_language: options.polishLanguage !== false,
        first_name: snapshot.first_name,
        last_name: snapshot.last_name,
        question_1: snapshot.question_1,
        question_2: snapshot.question_2,
        question_3: snapshot.question_3,
        feedback: snapshot.feedback,
      },
      { timeout: options.timeoutMs || 55000, skipRetry: true }
    );
  }

  async getAllPsFeedback({
    question1 = '',
    question2 = '',
    question3 = '',
    subject = '',
    oxbridge = false,
    sessionId = null,
    snapshot = {},
  } = {}) {
    // 3 parallel graph scores + one LLM polish often exceed 60s; do not retry on abort.
    return this.post(
      '/api/application-builder/get-feedback',
      {
        all_questions: true,
        subject,
        oxbridge: Boolean(oxbridge),
        session_id: sessionId || undefined,
        question_1: question1,
        question_2: question2,
        question_3: question3,
        first_name: snapshot.first_name,
        last_name: snapshot.last_name,
        feedback: snapshot.feedback,
      },
      { timeout: 120000, skipRetry: true }
    );
  }

  async exportPersonalStatement(snapshot) {
    return this.post('/api/application-builder/export-personal-statement', snapshot);
  }

  async listPersonalStatementVersions(firstName = '', lastName = '') {
    const params = new URLSearchParams({
      first_name: firstName || '',
      last_name: lastName || '',
    });
    return this.get(`/api/application-builder/personal-statement-versions?${params.toString()}`);
  }

  async getGraphFeedback({ elementId, content, subject = '', oxbridge = false, sessionId = null, document = null }) {
    return this.post('/api/application-builder/graph-feedback', {
      element_id: elementId,
      content,
      subject,
      oxbridge: Boolean(oxbridge),
      session_id: sessionId || undefined,
      document: document || undefined,
    });
  }

  async publishApplicationGraphs() {
    return this.post('/api/application-builder/publish-graphs', {});
  }

  async getDocumentLink(documentId) {
    return this.get(`/api/application-builder/documents/${documentId}/link`);
  }

  async openBuilderDocument(documentId, existingWindow) {
    const win = existingWindow || window.open('about:blank', '_blank');
    if (!win) {
      throw new Error('popup');
    }
    win.opener = null;
    try {
      const { url } = await this.getDocumentLink(documentId);
      win.location.href = url;
      return win;
    } catch (err) {
      win.close();
      throw err;
    }
  }

  async startSession(documentType) {
    return this.post('/api/application-builder/start-session', {
      document_type: documentType
    });
  }

  async trackEvent(sessionId, eventType, data = {}) {
    return this.post('/api/application-builder/track-event', {
      session_id: sessionId,
      event_type: eventType,
      ...data
    });
  }

  async getHealth() {
    return this.get('/api/application-builder/health');
  }
}

// Create and export application builder API instance
export const applicationBuilderAPI = new ApplicationBuilderAPI();



